export default function FavoritePets({onFavorites}) {
  return (
    <div onClick={onFavorites} className="favorites-indicator">
      <span className="heart-icon">❤️</span>
      <span className="favorites-count">3</span>
    </div>
  )
}